import React, { useState, useEffect, useCallback, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Card,
  Space,
  Typography,
  Button,
  message,
  Modal,
  Form,
  Alert,
  InputNumber,
  Divider,
} from "antd";
import {
  CalculatorFilled,
  PictureOutlined,
  PlusOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  saveDraftAsync,
  loadDraftAsync,
  getDraftsListAsync,
  updateFormData,
  addImagesToModule,
  removeImageFromModule,
  updateSteps,
  resetForm,
  checkDraftAvailability,
  processImagesAsync,
  initializeModuleGalleries,
  setError,
  clearError,
  clearDraft,
  fetchDraftsAsync
} from "@/stores/slice/reportSlice/inspectionSlice";
import InspectionHeader from "./components/InspectionHeader";
import InspectionReviewPage from "./InspectionReviewPage";
import CardBasedSteps from "./components/CardBasedSteps";
import superuserService from "@/services/event.service";
import inspectionService from "@/services/inspection.service";
import InspectionStepContent from "./components/InspectionStepContent ";
import StepImageGalleryDrawer from "./components/ImageGallery/StepImageGalleryDrawer";
import ImageGallery from "./components/ImageGallery";
import InspectionDB from "@/services/indexDB/inspectionStore";
import FeedbackModal from "../FeedbackPoup";
import { exportToPDF } from "./helper/pdfExport";
import { useNavigate, useParams } from "react-router-dom";
import { deepCompareFields } from "./helper/inspectionfun";
import formCreationService from "@/services/formconfiguration.service";
import InspectionBtn from "@/components/InspectionBtn";
import { useAuth } from "@/hooks/useAuth";
import toast from "react-hot-toast";
import { setSubscription } from "@/stores/slice/authSlice";

const { confirm } = Modal;

export default function InspectionReport() {
  const getparam = useParams();
  const dispatch = useDispatch();
  const {
    formData,
    gallery,
    galleryConfig,
    isDraftAvailable,
    isLoading,
    isUploading,
    uploadProgress,
    error,
    lastSaved,
    isOnline,
    pendingUploads,
    draftsList
  } = useSelector((state) => state.inspection);
  const [initialConfig, setInitialConfig] = useState([])
  const [db] = useState(() => new InspectionDB());
  const hasSetInitialConfig = useRef(false);
  const { user, role } = useAuth();
  const navigate = useNavigate()
  const shipinfo = useSelector((state) => state.ship);
  const userinfo = useSelector(data => data.auth)

  console.log("user", role)
  // Local state
  const [terminology, setTerminology] = useState("");
  const [unitlist, setUnitlist] = useState([]);
  const [action, setAction] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [eventlist, setEventList] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverTarget, setDragOverTarget] = useState(null);
  const [commonData, setCommonData] = useState({});
  const subscription = useSelector(state => state.auth)
  // New state for drawer
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false)

  // Add separate state for unit configuration
  const [unitConfiguration, setUnitConfiguration] = useState([]);

  // Form initialization
  const {
    control,
    watch,
    setValue,
    formState: { errors },
    handleSubmit,
    getValues,
    reset,
    trigger
  } = useForm({
    mode: 'onTouched',
    defaultValues: {
      eventType: null,
      dateTime: "",
      ...formData
    },
  });

  const {
    control: control1,
    getValues: getValues1,
    setValue: setValue1,
    handleSubmit: handleSubmit1
  } = useForm();
  const reportType = "INSPECTION_REPORT"

  // Watch form values
  const eventWatch = watch("eventType");
  const dateTimeWatch = watch("dateTime");
  const watchedSteps = watch("steps");

  // Get current module name for gallery organization
  const getCurrentModuleName = () => {
    if (watchedSteps && watchedSteps[currentStep]) {
      return watchedSteps[currentStep].name;
    }
    return 'general';
  };
  React.useEffect(() => {
    if (subscription && subscription.user)
      dispatch(fetchDraftsAsync({ user_id: subscription.user.user_id, reportType }));
  }, [subscription.user, reportType, dispatch]);

  // Initialize drafts list and check availability
  useEffect(() => {
    dispatch(getDraftsListAsync());
    dispatch(checkDraftAvailability());
  }, [dispatch]);


  useEffect(() => {
    const syncConfiguration = async () => {
      await db.syncAndClearFormConfigs()
    }
    if (role == "OWNER")
      syncConfiguration()
  }, [role])

  // Get all events
  const getallEvents = async () => {
    try {
      const report = reportType;
      const { data } = await superuserService.getInspectionAllEvent(subscription?.subscription.name);
      const localData = await db.getAllFormConfig(user.user_id, reportType);
      console.log("data", data)
      if (data) {
        // Merge but remove duplicates (API priority)
        const seen = new Set();
        const merged = [
          ...data,               // API events first
          ...(localData || []),  // Then local
        ].filter(event => {
          const key = `${event.event_type}_${event.reportType || ""}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        console.log("merged",merged)
        setEventList(merged);
      } else {
        setEventList([]);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
      setEventList([]);
    }
  };

  useEffect(() => {
    if (user)
      getallEvents();
  }, []);

  const checknativetype = ["minlength", "maxlength", "min", 'max'];

  const getModuledetails = async () => {
    try {
      let getpayload = []
      if (eventWatch?.__isNew__) {
        getpayload.push({
          name: "Tablename",
          id: "",
          description: "",
          guidance: [],
          tableName: "Tablename",
          components: null,
          commonComponents: null,
          units: [],
          newEvent: true,
          updateEvent: false
        });
      }
      else {
        const getEventId = eventlist?.find(x => x?.event_type === eventWatch?.value)
        try {
          const transformFormConfigs = (formConfigs = []) =>
            formConfigs.map((formConfig) => {
              const allFields = [
                ...(formConfig.nonCommonFields || []),
                ...(formConfig.commonFields || []),
              ];

              const allComponents = allFields.map((field) => ({
                name: field.name,
                type: field.type,
                required: field.required || false,
                isCommon: field.isCommon || false,
                guidance_text: field.guidance_text || "",
                placeholder: field.placeholder || "",
                ...(field.type === "image" && {
                  placeholderimage: field.placeholderimage || "",
                }),
                options: field.options
                  ? field.options.map((option) => ({
                    label:
                      typeof option === "string"
                        ? option
                        : option.label || option.value,
                    value:
                      typeof option === "string"
                        ? option
                        : option.value || option.label,
                  }))
                  : null,
              }));

              return {
                name: formConfig.name,
                id: formConfig.id,
                description: formConfig.formMeta?.description,
                guidance: formConfig.formMeta?.guidance,
                tableName: formConfig.tableName,
                components: allComponents.filter((c) => !c.isCommon),
                commonComponents: allComponents.filter((c) => c.isCommon),
                stepcount: formConfig.stepcount,
                units: [],
              };
            });

          // First try API
          const getmoduledetails = await inspectionService.getModulesforUser(getEventId?.id);
          const inserted = await db.insertIfNotExists(
            user.user_id,
            eventWatch?.value,
            reportType,
            getmoduledetails.data.formConfigurations
          );

          if (inserted) {
            console.log("✅ Inserted into IndexedDB");
          } else {
            console.log("⚡ Already exists, skipped insert");
          }
          if (getmoduledetails?.data?.formConfigurations) {
            getpayload = transformFormConfigs(getmoduledetails.data.formConfigurations);
          } else {
            // Fallback to local DB
            const getlocalDbdata = await db.getFormConfiguration(eventWatch?.label);
            getpayload = transformFormConfigs(getlocalDbdata?.formConfigurations || []);
          }

        } catch (error) {
          console.error("Error fetching module details:", error);
        }
      }

      if (getpayload && getpayload.length > 0) {
        if (!hasSetInitialConfig.current) {
          setInitialConfig(getpayload);
          hasSetInitialConfig.current = true;
        }

        setValue("steps", getpayload);
        dispatch(updateSteps(getpayload));

        // Initialize module galleries
        // dispatch(initializeModuleGalleries({ modules: getpayload }));
        const initialUnitConfig = getpayload.map(step => ({
          tablename: step.name,
          units: step.stepcount
        }));
        setUnitConfiguration(initialUnitConfig);
        setUnitlist(initialUnitConfig);

        setCurrentStep(0);
      }

    } catch (error) {
      console.error("Error fetching module details:", error);
      toast.error("Failed to load module details");
    }
  };

  useEffect(() => {
    if (action !== "LOAD" && eventWatch?.value && dateTimeWatch) {
      getModuledetails();
    }
  }, [action, eventWatch?.value, dateTimeWatch, hasSetInitialConfig]);

  // Enhanced image upload handler with module support
  const handleUpload = async (actualFiles, targetModule = 'general') => {
    try {
      dispatch(clearError());

      // Validate file types and sizes if galleryConfig exists
      if (galleryConfig) {
        const invalidFiles = actualFiles.filter(file => {
          return !galleryConfig.allowedTypes.includes(file.type) ||
            file.size > galleryConfig.maxImageSize;
        });

        if (invalidFiles.length > 0) {
          dispatch(setError(`Invalid files detected. Please check file types and sizes.`));
          return;
        }
      }

      const processedImages = await dispatch(
        processImagesAsync(actualFiles)
      ).unwrap();

      // Add images to specific module
      dispatch(addImagesToModule({
        module: targetModule,
        images: processedImages
      }));

      toast.success(`${processedImages.length} images added to ${targetModule}`);
    } catch (error) {
      console.error('Upload error:', error);
      dispatch(setError(`Failed to process images: ${error.message}`));
      throw error;
    }
  };

  // Enhanced camera capture handler
  const handleCameraCapture = async (file, targetModule = 'general') => {
    try {
      dispatch(clearError());

      const processedImages = await dispatch(
        processImagesAsync([file])
      ).unwrap();

      if (processedImages.length > 0) {
        dispatch(addImagesToModule({
          module: targetModule,
          images: processedImages
        }));

        toast.success(`Photo captured and added to ${targetModule}`);
      }
    } catch (error) {
      console.error('Camera capture error:', error);
      dispatch(setError(`Failed to process captured image: ${error.message}`));
      throw error;
    }
  };

  // Delete image handler
  const handleDeleteImage = (imageId, moduleKey) => {
    confirm({
      title: 'Delete Image',
      content: 'Are you sure you want to delete this image? This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        dispatch(removeImageFromModule({ module: moduleKey, imageId }));
        toast.success('Image deleted successfully');
      }
    });
  };

  // Create units dynamically
  const createUnitsForStep = useCallback((step, unitCount) => {
    const units = [];

    for (let i = 0; i < unitCount; i++) {
      const unit = {
        name: `${terminology ? terminology : "Unit"} ${i + 1}`,
        images: {},
        data: {}
      };

      step.components?.forEach(component => {
        if (component.type === "image") {
          unit.images[component.name] = null;
        } else {
          unit.data[component.name] = component.type === "radio" ? null :
            component.type === "checkbox" ? [] :
              component.type === "number" ? 0 : "";
        }
      });

      units.push(unit);
    }

    return units;
  }, [terminology]);

  // Update steps with dynamic units
  useEffect(() => {
    if (unitlist.length > 0 && watchedSteps?.length > 0) {
      const updatedSteps = watchedSteps.map(step => {
        const unitInfo = unitlist.find(u => u.tablename === step.name);
        const unitCount = unitInfo?.units || 1;

        if (!step.units || step.units.length === 0 || step.units.length !== unitCount) {
          return {
            ...step,
            units: createUnitsForStep(step, unitCount)
          };
        }

        return step;
      });

      const hasChanges = updatedSteps.some((step, index) =>
        !watchedSteps[index].units ||
        watchedSteps[index].units.length !== step.units.length
      );

      if (hasChanges) {
        setValue("steps", updatedSteps);
        dispatch(updateSteps(updatedSteps));
      }
    }
  }, [unitlist, watchedSteps, setValue, dispatch, createUnitsForStep, terminology]);

  // Replace getunitdetails with proper unit configuration handling
  const handleUnitConfigurationChange = useCallback((stepName, unitCount) => {
    const updatedUnitList = unitlist.map(item =>
      item.tablename === stepName
        ? { ...item, units: unitCount }
        : item
    );

    // If step doesn't exist in unitlist, add it
    if (!unitlist.find(item => item.tablename === stepName)) {
      updatedUnitList.push({ tablename: stepName, units: unitCount });
    }

    setUnitlist(updatedUnitList);
    setUnitConfiguration(updatedUnitList);
  }, [unitlist]);

  useEffect(() => {
    reset(formData);
  }, [formData, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
      reset();
      setCurrentStep(0);



    };
  }, [reset]);
  const handleFormChange = (field, value) => {
    setValue(field, value);
    dispatch(updateFormData({ [field]: value }));
  };

  // Handle unit data change
  const handleUnitDataChange = (stepIndex, unitIndex, componentName, value) => {
    const currentSteps = getValues("steps");
    if (!currentSteps[stepIndex].units[unitIndex].data) {
      currentSteps[stepIndex].units[unitIndex].data = {};
    }
    currentSteps[stepIndex].units[unitIndex].data[componentName] = value;
    setValue("steps", [...currentSteps]);
    dispatch(updateSteps(currentSteps));
  };

  // Handle common data change
  const handleCommonDataChange = (stepIndex, componentName, value) => {
    const currentSteps = getValues("steps");

    if (!currentSteps[stepIndex].commonData) {
      currentSteps[stepIndex].commonData = {};
    }
    currentSteps[stepIndex].commonData[componentName] = value;

    // Sync this value to all units in the current step
    currentSteps[stepIndex].units?.forEach((unit, unitIndex) => {
      if (componentName.includes('image') || componentName === 'image') {
        if (!currentSteps[stepIndex].units[unitIndex].images) {
          currentSteps[stepIndex].units[unitIndex].images = {};
        }
        currentSteps[stepIndex].units[unitIndex].images[componentName] = value;
      } else {
        if (!currentSteps[stepIndex].units[unitIndex].data) {
          currentSteps[stepIndex].units[unitIndex].data = {};
        }
        currentSteps[stepIndex].units[unitIndex].data[componentName] = value;
      }
    });

    setValue("steps", [...currentSteps]);
    dispatch(updateSteps(currentSteps));
  };

  // Enhanced image change handler
  const handleImageChange = async (file, stepIndex, unitIndex, componentName, isCommon, isFromCamera = false) => {
    try {
      const currentModule = getCurrentModuleName();
      const processedImages = await dispatch(
        processImagesAsync([file])
      ).unwrap();

      if (processedImages.length > 0) {
        const imageObject = processedImages[0];

        // Add to module gallery if not already there
        const moduleGallery = gallery[currentModule] || [];
        const existingImage = moduleGallery.find(img => img.id === imageObject.id);

        if (!existingImage) {
          dispatch(addImagesToModule({
            module: currentModule,
            images: [imageObject]
          }));
        }

        // Update form data
        if (isCommon) {
          handleCommonDataChange(stepIndex, componentName, imageObject);
        } else {
          const currentSteps = getValues("steps");
          if (!currentSteps[stepIndex].units[unitIndex].images) {
            currentSteps[stepIndex].units[unitIndex].images = {};
          }
          currentSteps[stepIndex].units[unitIndex].images[componentName] = imageObject;
          setValue("steps", [...currentSteps]);
          dispatch(updateSteps(currentSteps));
        }

      }
    } catch (error) {
      console.error('Error processing image:', error);
      toast.error('Failed to process image: ' + error.message);
    }
  };

  // Remove image handlers
  const handleRemoveImage = (stepIndex, unitIndex, componentName, isCommon) => {
    if (isCommon) {
      const newCommonData = {
        ...commonData,
        [stepIndex]: {
          ...commonData[stepIndex],
          [componentName]: null
        }
      };
      setCommonData(newCommonData);
    } else {
      const currentSteps = getValues("steps");
      currentSteps[stepIndex].units[unitIndex].images[componentName] = null;
      setValue("steps", [...currentSteps]);
      dispatch(updateSteps(currentSteps));
    }
  };

  // Enhanced save draft function
  const handleSaveDraft = async () => {
    try {
      const currentFormData = getValues();
      if (!currentFormData.eventType || !currentFormData.dateTime) {
        toast.error("Please fill in Event Type, Date, and Time before saving draft");
        return;
      }

      const draftData = {
        ...currentFormData,
        eventType: currentFormData.eventType?.value,
        reportType: reportType,
        user_id: subscription.user.user_id,
        gallery, // Now includes module-based structure
        commonData,
        unitConfiguration, // Save unit configuration
      };

      await dispatch(saveDraftAsync(draftData)).unwrap();
      toast.success("Draft saved successfully!");
    } catch (error) {
      toast.error("Failed to save draft: " + error);
    }
  };

  // Enhanced load draft function
  const handleLoadDraft = async (draftKey) => {
    try {
      setAction("LOAD");
      const result = await dispatch(loadDraftAsync(draftKey)).unwrap();
      if (result) {
        // Set terminology based on loaded event type
        // const getTerminology = eventlist?.find(x => x?.event_type === result.eventType);
        // setTerminology("Tanks" || '');

        // Load common data if available
        if (result.commonData) {
          setCommonData(result.commonData);
        }

        // Load unit configuration if available
        if (result.unitConfiguration) {
          setUnitConfiguration(result.unitConfiguration);
          setUnitlist(result.unitConfiguration);
        }
        setValue("eventType", { label: result?.eventType, value: result?.eventType })
        toast.success("Draft loaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to load draft: " + error);
    }
  };

  // Check if image is assigned across all modules
  const isImageAssigned = (imageId) => {
    try {
      const currentSteps = getValues("steps");
      if (!currentSteps || !Array.isArray(currentSteps)) {
        return false;
      }

      const unitAssigned = currentSteps.some((step) => {
        if (!step.units || !Array.isArray(step.units)) return false;

        return step.units.some((unit) => {
          if (!unit.images || typeof unit.images !== 'object') return false;

          return Object.values(unit.images).some(
            (image) => image && typeof image === 'object' && image.id === imageId
          );
        });
      });

      const commonAssigned = Object.values(commonData || {}).some(stepCommonData => {
        if (!stepCommonData || typeof stepCommonData !== 'object') return false;

        return Object.values(stepCommonData).some(
          (image) => image && typeof image === 'object' && image.id === imageId
        );
      });

      return unitAssigned || commonAssigned;
    } catch (error) {
      console.error('Error checking if image is assigned:', error);
      return false;
    }
  };

  const handleDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = "move";

    // Set comprehensive drag data with multiple formats for compatibility
    const dragData = {
      imageId: item.id,
      sourceModule: 'general',
      imageData: {
        id: item.id,
        url: item.url,
        name: item.name,
        uploaded: item.uploaded || true
      }
    };

    try {
      e.dataTransfer.setData('application/json', JSON.stringify(dragData));
      e.dataTransfer.setData('text/plain', JSON.stringify(dragData));
      e.dataTransfer.setData('text/html', JSON.stringify(dragData));

      // Individual pieces as fallback
      e.dataTransfer.setData('image/id', item.id);
      e.dataTransfer.setData('image/url', item.url);
      e.dataTransfer.setData('image/name', item.name);
    } catch (error) {
      console.error('Error setting drag data:', error);
    }
  };

  const handleDragOver = (e, stepIndex, unitIndex, componentName, isCommon = false) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "move";

    // Only update if target changed to prevent excessive re-renders
    const newTarget = { stepIndex, unitIndex, componentName, isCommon };
    const currentTarget = dragOverTarget;

    if (!currentTarget ||
      currentTarget.stepIndex !== newTarget.stepIndex ||
      currentTarget.unitIndex !== newTarget.unitIndex ||
      currentTarget.componentName !== newTarget.componentName ||
      currentTarget.isCommon !== newTarget.isCommon) {
      setDragOverTarget(newTarget);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Use setTimeout to handle rapid enter/leave events
    setTimeout(() => {
      const rect = e.currentTarget?.getBoundingClientRect();
      if (rect) {
        const x = e.clientX;
        const y = e.clientY;

        // Check if mouse is actually outside the element
        if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
          setDragOverTarget(null);
        }
      }
    }, 50);
  };

  const handleDrop = (e, stepIndex, unitIndex, componentName, isCommon = false) => {
    e.preventDefault();
    e.stopPropagation();
    setDragOverTarget(null);

    try {
      let dragData = null;
      let imageData = null;

      // Try multiple data formats
      const formats = ['application/json', 'text/plain', 'text/html'];

      for (const format of formats) {
        const data = e.dataTransfer.getData(format);
        if (data) {
          try {
            dragData = JSON.parse(data);
            imageData = dragData.imageData || dragData;
            break;
          } catch (parseError) {
            console.warn('Failed to parse data from format:', format, parseError);
          }
        }
      }

      // Fallback: try to reconstruct from individual pieces
      if (!imageData) {
        const imageId = e.dataTransfer.getData('image/id');
        const imageUrl = e.dataTransfer.getData('image/url');
        const imageName = e.dataTransfer.getData('image/name');

        if (imageId && imageUrl) {
          imageData = {
            id: imageId,
            url: imageUrl,
            name: imageName || 'Unknown',
            uploaded: true
          };
        }
      }

      if (!imageData) {
        console.error('No valid image data found in drop event');
        toast.error('Failed to assign image - no valid data found');
        return;
      }

      // Validate required fields
      if (!imageData.id || !imageData.url) {
        console.error('Invalid image data structure:', imageData);
        toast.error('Invalid image data - missing required fields');
        return;
      }

      // Update form data
      if (isCommon) {
        handleCommonDataChange(stepIndex, componentName, imageData);
      } else {
        const currentSteps = getValues("steps");
        if (!currentSteps[stepIndex]) {
          console.error('Invalid step index:', stepIndex);
          return;
        }
        if (!currentSteps[stepIndex].units[unitIndex]) {
          console.error('Invalid unit index:', unitIndex);
          return;
        }

        if (!currentSteps[stepIndex].units[unitIndex].images) {
          currentSteps[stepIndex].units[unitIndex].images = {};
        }
        currentSteps[stepIndex].units[unitIndex].images[componentName] = imageData;
        setValue("steps", [...currentSteps]);
        dispatch(updateSteps(currentSteps));
      }


    } catch (error) {
      console.error('Drop error:', error);
      toast.error('Failed to assign image: ' + error.message);
    }

    setDraggedItem(null);
  };

  // Handle opening step image gallery drawer
  const handleOpenStepGallery = () => {
    setDrawerVisible(true);
  };

  // Handle steps update from CardBasedSteps component
  const handleStepsUpdate = useCallback((updatedSteps) => {
    // Process steps to ensure they have proper units
    const processedSteps = updatedSteps.map(step => {
      const existingStep = watchedSteps?.find(existing => existing.id === step.id || existing.name === step.name);

      if (!existingStep || !step.units || step.units.length === 0) {
        const unitInfo = unitlist.find(u => u.tablename === step.name);
        const unitCount = unitInfo?.units || 1;

        return {
          ...step,
          units: createUnitsForStep(step, unitCount)
        };
      }

      return step;
    });

    setValue("steps", processedSteps);
    dispatch(updateSteps(processedSteps));

    // Initialize galleries for new steps
    dispatch(initializeModuleGalleries({ modules: processedSteps }));

    // Update unit configurations
    const newUnitItems = processedSteps.map(step => ({
      tablename: step.name,
      units: unitlist.find(u => u.tablename === step.name)?.units || 1
    }));

    const existingTableNames = unitlist.map(u => u.tablename);
    const hasNewSteps = newUnitItems.some(item => !existingTableNames.includes(item.tablename));

    if (hasNewSteps) {
      setUnitlist(newUnitItems);
      setUnitConfiguration(newUnitItems);
    }

    // Adjust currentStep if necessary
    const totalSteps = processedSteps.length + 1;
    if (currentStep >= totalSteps - 1) {
      setCurrentStep(totalSteps - 1);
    } else if (currentStep >= processedSteps.length) {
      setCurrentStep(Math.max(0, processedSteps.length - 1));
    }

  }, [watchedSteps, unitlist, createUnitsForStep, setValue, dispatch, currentStep]);
  // Generate submission payload
  const generateSubmissionPayload = () => {
    const formValues = getValues();
    const payload = {
      eventType: formValues.eventType?.value,
      reportType: reportType,
      dateTime: formValues.dateTime,
      timestamp: new Date().toISOString(),
      data: [],
      imo_number: shipinfo?.selectedShipId,
      user_id: subscription?.user?.user_id,
      synced: false
    };

    formValues.steps?.forEach((step, stepIndex) => {
      // Get common components for this step
      const commonComponents = step.commonComponents || [];
      const commonComponentNames = commonComponents.map(comp => comp.name);

      // Extract common data and images from step.commonData
      const commonFormData = {};
      const commonImages = [];

      // Handle common data from step.commonData if it exists
      if (step.commonData) {
        Object.entries(step.commonData).forEach(([key, value]) => {
          if (key.endsWith("_index")) return;

          // Check if this is an image component
          const isImageComponent = commonComponents.find(comp => comp.name === key && comp.type === 'image');

          if (isImageComponent && value && typeof value === 'object' && value.id) {
            // Handle common image
            commonImages.push({
              component_name: key,
              image_id: value.id,
              image_name: value.name,
              image_url: value.url,
              uploaded: value.uploaded || false,
            });
          } else {
            // Handle other common form data (text, dropdown, etc.)
            if (Array.isArray(value)) {
              commonFormData[key] = value.join(",");
            } else if (typeof value === 'object' && value !== null) {
              // Skip objects that are images (already handled above)
              if (!value.id || !value.url) {
                commonFormData[key] = JSON.stringify(value);
              }
            } else {
              commonFormData[key] = value;
            }
          }
        });
      }

      const stepData = {
        step_name: step.name,
        step_index: stepIndex,
        common_data: {
          form_data: commonFormData,
          images: commonImages
        },
        units: []
      };

      step.units?.forEach((unit, unitIndex) => {
        const unitSpecificData = {};
        const unitSpecificImages = [];

        // Process unit data
        Object.entries(unit.data || {}).forEach(([key, value]) => {
          if (key.endsWith("_index")) return;

          // Only include if it's NOT a common component
          if (!commonComponentNames.includes(key)) {
            if (Array.isArray(value)) {
              unitSpecificData[key] = value.join(",");
            } else {
              unitSpecificData[key] = value;
            }
          }
        });

        if (unit.images) {
          Object.entries(unit.images).forEach(([componentName, image]) => {
            if (image && image.id) {
              const imageData = {
                component_name: componentName,
                image_id: image.id,
                image_name: image.name,
                image_url: image.url,
              };

              if (commonComponentNames.includes(componentName)) {
                unitCommonImages.push(imageData);
              } else {
                unitSpecificImages.push(imageData);
              }
            }
          });
        }

        const unitData = {
          unit_name: unit.name,
          unit_index: unitIndex,
          form_data: unitSpecificData,
          images: unitSpecificImages, // Only unit-specific images
        };

        stepData.units.push(unitData);
      });

      payload.data.push(stepData);
    });

    return payload;
  };

  const fieldsToCheck = ["commonComponents", "components", "name"];
  const onSaveFeedback = async (payload) => {
    try {
      const feedbackPayload = {
        ...payload,
        dateTime: dateTimeWatch,
        event: eventWatch?.value,
      };
      if (subscription?.subscription?.no_of_inspection_reports <= 0) {
        alert("Limit is Over")
        return
      }
      let subscriptionpayload = subscription?.subscription
      // First save feedback
      await inspectionService.postFeeback(feedbackPayload);

      // Now continue with main submission
      const submissionPayload = generateSubmissionPayload();
      const getShipinfo = await inspectionService.getshipById(shipinfo.selectedShipId);
      const metadata = await db.getFormConfigsByEventType(submissionPayload?.eventType);
      exportToPDF(submissionPayload, getShipinfo, userinfo?.user, metadata?.map(x => x?.formConfigurations)[0]);


      if (watchedSteps?.find(x => x?.newEvent)) {
        try {
          const generateFormConfig = watchedSteps?.map(step => ({
            tableName: step?.name,
            name: step?.name,
            nonCommonFields: step?.components || [],
            commonFields: step?.commonComponents || [],
            createdBy: subscription?.user?.user_id,
            isGlobal: false,
            stepcount: step?.units?.length
          })) || [];
          await db.saveFormConfiguration(subscription?.user?.user_id, eventWatch?.value, reportType, generateFormConfig);
          subscriptionpayload = { ...subscriptionpayload, max_events: subscriptionpayload.max_events - 1 };

        } catch (error) {
          console.error("Error saving form configuration:", error);
        }
      }
      else if (deepCompareFields(initialConfig, watchedSteps, fieldsToCheck)) {
        try {
          const generateFormConfig = watchedSteps?.map(step => ({
            tableName: step?.name,
            nonCommonFields: step?.components || [],
            commonFields: step?.commonComponents || [],
            createdBy: subscription.user?.user_id,
            isGlobal: false,
          })) || [];

          await db.saveFormConfiguration(subscription?.user.user_id, eventWatch?.value + "_modified", reportType, generateFormConfig);
          subscriptionpayload = { ...subscriptionpayload, max_events: subscriptionpayload.max_events - 1 };

        } catch (error) {
          console.error("Error saving form configuration:", error);
        }
      }
      await db.createInspection(subscription?.user.user_id, submissionPayload);
      subscriptionpayload = { ...subscriptionpayload, no_of_inspection_reports: subscriptionpayload?.no_of_inspection_reports - 1 };

      if (subscription?.subscription?.cloud_save) {
        await inspectionService.insertInspectionReport(submissionPayload);
      }

      toast.success("Report submitted successfully!");
      dispatch(setSubscription(subscriptionpayload))
      // Reset everything
      await dispatch(clearDraft());
      dispatch(resetForm());
      reset();
      setCurrentStep(0);
      setCommonData({});
      setUnitConfiguration([]);
      setUnitlist([]);
      // navigate("/user/inspectionlist");

    } catch (error) {
      toast.error("Failed to submit report: " + error);
    }
  };

  // Handle form submission
  const onSubmit = async () => {
    try {
      setModalVisible(true)
    } catch (error) {
      toast.error("Failed to submit report: " + error);
    }
  };

  // Step navigation
  const totalSteps = (watchedSteps?.length || 0) + 1;
  const isReviewStep = currentStep === totalSteps - 1;

  const handleStepChange = (step) => {
    const maxStep = Math.max(0, totalSteps - 1);
    const validStep = Math.min(step, maxStep);
    setCurrentStep(validStep);
  };

  const handleNextStep = async () => {
    const isValid = await trigger();
    if (isValid && currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };


  // Add effect to handle unit changes and update steps accordingly
  useEffect(() => {
    if (unitlist.length > 0 && watchedSteps?.length > 0) {
      const updatedSteps = watchedSteps.map(step => {
        const unitInfo = unitlist.find(u => u.tablename === step.name);
        const targetUnitCount = unitInfo?.units || 1;
        const currentUnitCount = step.units?.length || 0;

        // Only update if unit count has changed
        if (currentUnitCount !== targetUnitCount) {
          let newUnits = [];

          if (targetUnitCount > currentUnitCount) {
            // Add more units
            newUnits = [...(step.units || [])];
            for (let i = currentUnitCount; i < targetUnitCount; i++) {
              const newUnit = {
                name: `${terminology ? terminology : "Unit"} ${i + 1}`,
                images: {},
                data: {}
              };

              // Initialize data structure for new units
              step.components?.forEach(component => {
                if (component.type === "image") {
                  newUnit.images[component.name] = null;
                } else {
                  newUnit.data[component.name] = component.type === "radio" ? null :
                    component.type === "checkbox" ? [] :
                      component.type === "number" ? 0 : "";
                }
              });

              newUnits.push(newUnit);
            }
          } else {
            // Remove excess units
            newUnits = step.units?.slice(0, targetUnitCount) || [];
          }

          return {
            ...step,
            units: newUnits
          };
        }

        return step;
      });

      // Check if any changes were made
      const hasChanges = updatedSteps.some((step, index) => {
        const originalStep = watchedSteps[index];
        return !originalStep.units ||
          originalStep.units.length !== step.units.length;
      });

      if (hasChanges) {
        setValue("steps", updatedSteps);
        dispatch(updateSteps(updatedSteps));
      }
    }
  }, [unitlist, watchedSteps, setValue, dispatch, terminology]);

  const handleUploadToGeneral = async (actualFiles, targetModule = 'general') => {
    try {
      dispatch(clearError());

      // Validate files
      if (!actualFiles || !Array.isArray(actualFiles) || actualFiles.length === 0) {
        console.error('No valid files provided');
        toast.error('No files provided for upload');
        return;
      }

      // Filter valid files
      const validFiles = actualFiles.filter(file => {
        const isValid = file instanceof File;
        if (!isValid) {
          console.warn('Invalid file:', file);
        }
        return isValid;
      });

      if (validFiles.length === 0) {
        console.error('No valid File objects');
        toast.error('No valid files to upload');
        return;
      }

      // Process images
      const processedImages = await dispatch(
        processImagesAsync(validFiles)
      ).unwrap();

      if (!processedImages || processedImages.length === 0) {
        console.error('processImagesAsync returned empty result');
        toast.error('Failed to process images');
        return;
      }

      const moduleToUse = 'general';

      dispatch(addImagesToModule({
        module: moduleToUse,
        images: processedImages
      }));

      toast.success(`${processedImages.length} images added to ${moduleToUse}`);

    } catch (error) {
      console.error('Upload error:', error);
      toast.error(`Upload failed: ${error.message}`);
    }
  };

  const handleUploadToStep = async (actualFiles, targetModule) => {
    try {
      dispatch(clearError());

      // Validate file types and sizes
      if (galleryConfig) {
        const invalidFiles = actualFiles.filter(file => {
          return !galleryConfig.allowedTypes?.includes(file.type) ||
            file.size > (galleryConfig.maxImageSize || 5000000);
        });

        if (invalidFiles.length > 0) {
          toast.error(`Invalid files detected. Please check file types and sizes.`);
          return;
        }
      }

      const processedImages = await dispatch(
        processImagesAsync(actualFiles)
      ).unwrap();

      // Add images to specific module
      dispatch(addImagesToModule({
        module: targetModule,
        images: processedImages
      }));

      const moduleDisplayName = targetModule === 'general' ? 'General Gallery' : targetModule;
      toast.success(`${processedImages.length} images added to ${moduleDisplayName}`);
    } catch (error) {
      console.error('Step upload error:', error);
      dispatch(setError(`Failed to process images: ${error.message}`));
      toast.error(`Upload failed: ${error.message}`);
    }
  };

  const handleStepUpdate = (stepIndex, updatedStep) => {
    const currentSteps = getValues("steps");
    const newSteps = [...currentSteps];
    newSteps[stepIndex] = updatedStep;

    setValue("steps", newSteps);
    dispatch(updateSteps(newSteps));
  };
  const handleAddUnit = useCallback((stepIndex) => {
    const currentSteps = getValues("steps");
    const step = currentSteps[stepIndex];

    if (!step) return;

    const currentUnitCount = step.units?.length || 0;
    const newUnitIndex = currentUnitCount;

    // Create new unit with proper structure
    const newUnit = {
      name: `${terminology || "Unit"} ${newUnitIndex + 1}`,
      images: {},
      data: {}
    };

    // Initialize data structure based on step components
    step.components?.forEach(component => {
      if (component.type === "image") {
        newUnit.images[component.name] = null;
      } else {
        newUnit.data[component.name] = component.type === "radio" ? null :
          component.type === "checkbox" ? [] :
            component.type === "number" ? 0 : "";
      }
    });

    // Add the new unit to the step
    const updatedSteps = [...currentSteps];
    if (!updatedSteps[stepIndex].units) {
      updatedSteps[stepIndex].units = [];
    }
    updatedSteps[stepIndex].units.push(newUnit);

    // Update form and Redux state
    setValue("steps", updatedSteps);
    dispatch(updateSteps(updatedSteps));

    // Update unit configuration
    const updatedUnitList = unitlist.map(item =>
      item.tablename === step.name
        ? { ...item, units: updatedSteps[stepIndex].units.length }
        : item
    );

    setUnitlist(updatedUnitList);
    setUnitConfiguration(updatedUnitList);

    toast.success(`${terminology || "Unit"} added successfully to ${step.name}`);
  }, [getValues, setValue, dispatch, unitlist, terminology]);

  // Remove unit from specific step
  const handleRemoveUnit = useCallback((stepIndex, unitIndex) => {
    const currentSteps = getValues("steps");
    const step = currentSteps[stepIndex];

    if (!step || !step.units || step.units.length <= 1) {
      toast.error("Cannot remove the last unit. At least one unit is required.");
      return;
    }

    confirm({
      title: 'Remove Unit',
      content: `Are you sure you want to remove "${step.units[unitIndex].name}"? This action cannot be undone.`,
      okText: 'Remove',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        const updatedSteps = [...currentSteps];
        updatedSteps[stepIndex].units.splice(unitIndex, 1);

        // Renumber remaining units
        updatedSteps[stepIndex].units.forEach((unit, index) => {
          unit.name = `${terminology || "Unit"} ${index + 1}`;
        });

        // Update form and Redux state
        setValue("steps", updatedSteps);
        dispatch(updateSteps(updatedSteps));

        // Update unit configuration
        const updatedUnitList = unitlist.map(item =>
          item.tablename === step.name
            ? { ...item, units: updatedSteps[stepIndex].units.length }
            : item
        );

        setUnitlist(updatedUnitList);
        setUnitConfiguration(updatedUnitList);

        toast.success(`${terminology || "Unit"} removed successfully from ${step.name}`);
      }
    });
  }, [getValues, setValue, dispatch, unitlist, terminology]);


  return (
    <div className="min-h-screen bg-gray-100  ">

      <div className="w-full sm:px-2  ">
        <InspectionHeader
          control={control}
          eventlist={eventlist}
          terminology={terminology}
          setTerminology={setTerminology}
          handleFormChange={handleFormChange}
          handleSaveDraft={handleSaveDraft}
          isLoading={isLoading}
          isDraftAvailable={isDraftAvailable}
          lastSaved={lastSaved}
          onDraftSelected={handleLoadDraft}
          currentFormData={getValues()}
          draftsList={draftsList}
        />

        <FeedbackModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          onSaveFeedback={onSaveFeedback}
        />

        {/* Error Alert */}
        {error && (
          <Alert
            message="Error"
            description={error}
            type="error"
            closable
            onClose={() => dispatch(clearError())}
            style={{ marginBottom: "20px" }}
          />
        )}

        {/* General Image Gallery - Only show when not in review step */}
        {!isReviewStep && (
          <ImageGallery
            gallery={gallery}
            modules={watchedSteps || []}
            onUpload={handleUploadToStep}
            onCameraCapture={handleCameraCapture}
            onDragStart={handleDragStart}
            isImageAssigned={isImageAssigned}
            isVisible={!isReviewStep}
            onDeleteImage={handleDeleteImage}
            showDeleteButton={true}
            currentStepName={getCurrentModuleName()}
          />
        )}

        <StepImageGalleryDrawer
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          gallery={gallery}
          modules={watchedSteps || []}
          onUpload={handleUpload}
          onCameraCapture={handleCameraCapture}
          onDeleteImage={handleDeleteImage}
          isImageAssigned={isImageAssigned}
          currentStepName={watchedSteps && watchedSteps[currentStep]?.name}
          stepIndex={currentStep}
        />

        {/* Unit Configuration Modal */}

        {/* Main Content */}
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={24}>
            {/* Step Navigation */}
            {watchedSteps && watchedSteps.length > 0 && (
              <div className="bg-gray-200 px-2 rounded-2xl my-1">
                <CardBasedSteps
                  watchedSteps={watchedSteps}
                  currentStep={currentStep}
                  onStepChange={handleStepChange}
                  onStepsUpdate={handleStepsUpdate}
                />
              </div>
            )}

            {/* Content Area */}
            {currentStep !== 0 && isReviewStep ? (
              <InspectionReviewPage
                formData={getValues()}
                commonData={commonData}
                onBack={handlePrevStep}
                onSubmit={handleSubmit(onSubmit)}
                isLoading={isLoading}
                isOnline={isOnline}
                pendingUploads={pendingUploads}
              />
            ) : (
              <Card
                size="small"
                title={
                  <div className="flex justify-between">
                    <div>
                      <Typography.Text strong className="fs-16 text-capitalize">
                        {watchedSteps && watchedSteps[currentStep]?.name}
                      </Typography.Text>
                    </div>
                    {watchedSteps && watchedSteps.length > 0 && (
                      <div className="flex   gap-3">

                        <InspectionBtn
                          variant="primary"
                          size="xs"
                          onClick={() => handleAddUnit(currentStep)}
                          icon={<PlusOutlined />}
                        >
                          Add Unit
                        </InspectionBtn>



                        <InspectionBtn
                          variant="primary"
                          size="xs"
                          onClick={handleOpenStepGallery}
                          icon={<PictureOutlined />}
                        >
                          Get Images
                        </InspectionBtn>


                      </div>
                    )}
                  </div>
                }
              >
                {watchedSteps &&
                  watchedSteps.length > 0 &&
                  watchedSteps[currentStep] ? (
                  <InspectionStepContent
                    step={watchedSteps[currentStep]}
                    stepIndex={currentStep}
                    control={control}
                    onFormChange={handleFormChange}
                    onUnitDataChange={handleUnitDataChange}
                    onCommonDataChange={handleCommonDataChange}
                    onImageChange={handleImageChange}
                    onRemoveImage={handleRemoveImage}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    dragOverTarget={dragOverTarget}
                    onStepUpdate={handleStepUpdate}
                    onAddUnit={handleAddUnit}
                    onRemoveUnit={handleRemoveUnit}
                    terminology={terminology}
                  />
                ) : (
                  <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                    <CalculatorFilled size={48} style={{ marginBottom: "16px", opacity: 0.5 }} />
                    <div style={{ fontSize: "16px", marginBottom: "8px" }}>
                      No Steps Available
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      Please select an event type, date, and time to load the inspection steps.
                    </div>
                  </div>
                )}

                {/* Step Navigation Buttons */}
                {watchedSteps && watchedSteps.length > 0 && (
                  <div className="mb-10 mt-2 flex justify-center">
                    <Space>
                      <InspectionBtn
                        onClick={handlePrevStep}
                        disabled={currentStep === 0}
                      >
                        Previous
                      </InspectionBtn>

                      <InspectionBtn
                        type="primary"
                        onClick={handleNextStep}
                        disabled={currentStep >= totalSteps - 1}
                      >
                        {currentStep === totalSteps - 2 ? "Review" : "Next"}
                      </InspectionBtn>
                    </Space>
                  </div>
                )}
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}